import {
    PublicClientApplication,
    AuthenticationResult,
    AccountInfo,
    EndSessionRequest,
    RedirectRequest,
    PopupRequest,
    SilentRequest,
    AuthorizationCodeRequest,
} from "@azure/msal-browser";

import { MSAL_CONFIG } from "src/azure/azure-authentication-config";

const AzureActiveDirectoryAppClientId: any = process.env.REACT_APP_MS_CLIENT_ID;
const redirectURL = process.env.REACT_APP_SERVER_MS_REDIRECT_URL;
const TenantId: any = process.env.REACT_APP_MS_TENANT_ID;

export class AzureAuthenticationContext {
    private myMSALObj: PublicClientApplication = new PublicClientApplication(MSAL_CONFIG);
    private account?: AccountInfo;
    private loginRedirectRequest?: RedirectRequest;
    private loginRequest?: PopupRequest;
    private silentRequest? : SilentRequest;
    private codeRequest? : AuthorizationCodeRequest;
    public isAuthenticationConfigured = false;

    constructor() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.account = null;
        this.setRequestObjects();
        if (MSAL_CONFIG?.auth?.clientId) {
            this.isAuthenticationConfigured = true;
        }
    }

    
    private setRequestObjects(): void {
        this.loginRequest = {
            scopes: ["User.Read"],
            // domainHint : "fnfcorp.com",
            // authority : "https://login.microsoftonline.com/"+TenantId,
            // authority : "tHV7Q~QmXH0F9n43nLGln1DCBASp24bh3luk4",
            // authority : "https://login.microsoftonline.com/c0f5d9c6-f2df-4b78-85aa-5d4d82ce0cb5/oauth2/v2.0/token",
            // claims : "typ",
            // tokenQueryParameters : {"response_mode":"form_post"},
            // extraQueryParameters : {"response_mode":"fragment"},
            // scopes: [],
            // prompt: "select_account",
            // resourceRequestMethod : "",
            // extraQueryParameters: { domain_hint: "organizations" },
        };

        this.loginRedirectRequest = {
            ...this.loginRequest,
            redirectStartPage: window.location.href,
            scopes : ["User.Read"],
        };
        this.silentRequest = {
            scopes :  ["User.Read"],
            forceRefresh : false,
            account : this.account
        }
       
    }

      login(signInType: string, setUser: any): void {
        if (signInType === "loginPopup") {
            this.myMSALObj
                .loginPopup(this.loginRequest)
                .then((resp: AuthenticationResult) => {
                    this.handleResponse(resp, setUser);
                })
                .catch((err) => {
                    console.error(err);
                });
        } else if (signInType === "loginRedirect") {



            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const setAccount : AccountInfo  = {tenantId : TenantId}; 
            this.myMSALObj.acquireTokenSilent({scopes : ["User.Read"], account : setAccount}).then((response : AuthenticationResult) => {
                console.log(response);
                this.handleResponse(response, setUser);
            })


            // this.myMSALObj.acquireTokenSilent({scopes : ["User.Read"]}).then((response : AuthenticationResult) => {
            //     this.handleResponse(response, setUser);
            // }).catch((error) => {
            //     this.myMSALObj.acquireTokenRedirect({scopes : ["User.Read"]}).then(() => {
            //         console.log(error);
            //         console.log(this.account);
            //     }).catch((error) => {
            //         console.log(error);
            //         console.log(this.account);
            //     })
            // })
            // this.myMSALObj.loginRedirect(this.loginRedirectRequest).then((response : any) => {
            //     this.handleResponse(response, setUser);

            // }).catch((error) => {   
            //     console.log(error);
            // })
            // 여기서 token 값을 정재 하나?
            const token = this.myMSALObj.acquireTokenRedirect({scopes:["User.Read"], authority:"https://login.microsoftonline.com/"+TenantId});
            setUser(token);
            
        }
    }

    logout(account: AccountInfo): void {
        const logOutRequest: EndSessionRequest = {
            account,
        };

        this.myMSALObj.logout(logOutRequest);
    }

    
    handleResponse(response: AuthenticationResult, incomingFunction: any) {
        if (response !== null) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.account = {tenantId : response.account?.tenantId};
            this.account!.name = response.accessToken;
            // this.account.name = response.accessToken;
        } else {
            this.account = this.getAccount();
        }
        
        if (this.account) {
            incomingFunction(this.account);
        }
    }

    private getAccount(): AccountInfo | undefined {
        const currentAccounts = this.myMSALObj.getAllAccounts();
        if (currentAccounts === null) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return undefined;
        }

        if (currentAccounts.length > 1) {
            // TBD: Add choose account code here
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            console.log("Multiple accounts detected, need to add choose account code.");
            return currentAccounts[0];
        } else if (currentAccounts.length === 1) {
            return currentAccounts[0];
        }
    }
}

export default AzureAuthenticationContext;
